import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import ModalContainer from '../../common/modal/ModalContainer'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import { ReactComponent as UploadIcon } from '../../../assets/icons/upload.svg'
import { ReactComponent as ChatIcon } from '../../../assets/icons/chat.svg'
import { ReactComponent as AiMagicIcon } from '../../../assets/icons/ai-magic.svg'
import { ReactComponent as CopyIcon } from '../../../assets/icons/copy.svg'
import {
    fetchCollectionMembersByProductId,
    fetchDesignDocs,
    fetchDesignInfoById,
    fetchExploreDesigns
} from '../../services/v3/DesignLab/DesignLab'
import { useDispatch } from 'react-redux'
import { closeLoader, openLoader } from '../../redux_toolkit/Loader'
import {
    capitalizeFirstAndLowercaseRest,
    convertNumberToUSFormat,
    getFileType,
    getIconByFileType,
    getShortName,
    isPickAndChooseBuyer
} from '../../helpers/Util'
import { toast } from 'react-toastify'
import Tooltip from '@mui/material/Tooltip'
import {
    addMixpanelTrackingEvent,
    addProductBulkImages,
    callProductTracker,
    fetchSetInfoById
} from '../../services/CommonService'
import { CommonActions, useGlobalState } from '../../redux_toolkit/V3/Common'
import {
    ADD_PRODUCT_TRACK_ID,
    CLEAR_PRODUCT_TRACK_ID,
    GET_FAVOURITE_COUNT,
    SELECT_DESIGN_FOR_FAVOURITE,
    UNSELECT_DESIGN_FOR_FAVOURITE
} from '../../redux_toolkit/@types/thunk.types'
import AddToFavourite from './AddToFavourite'
import PackSetOrTag from './PackOrSetTag'
import DesignCardView from './DesignCardView'
import { DoFavouriteThunk } from '../../redux_toolkit/V3/DoFavourite/DoFavouriteThunk'
import { FavouriteThunks } from '../../redux_toolkit/Favourite/FavouriteThunks'
import { FilterActionTypes } from '../../redux_toolkit/V3/Filter'
import { ADD_FILTER_FIELDS } from '../../redux_toolkit/@types/action.types'
import FavoriteIcon from '../../common/FavoriteIcon'
import Image from '../../common/Image'
import { BASE_FRONT_END_URL } from '../../constant'
import LoaderComponent from '../../common/LoaderComponent'

const DesignViewModal = ({
    openModal,
    onCloseModal,
    styleId,
    toggleFavouriteModal,
    isShowConversation = true,
    isHideBottom = false,
    setCollectionMembers,
    toggleConversation,
    requestFrom,
    styleInfo = null
}) => {
    const [featureImageDocs, setFeatureImageDocs] = useState({})
    const [virtualTryOnDocResponse, setVirtualTryOnDocResponse] = useState(null)
    const [showFavourite, setShowFavourite] = useState(false)
    const [isViewAllClicked, setIsViewAllClicked] = useState(false)
    const [selectedZoom, setSelectedZoom] = useState(null)
    const [setStyleInfo, setSetStyleIfo] = useState(null)
    const [designInfo, setDesignInfo] = useState(null)
    const [designDocs, setDesignDocs] = useState([])
    const [designList, setDesignList] = useState([])
    const [totalSimilarItems, setTotalSimilarItems] = useState(null)
    const [filterOptions, setFilterOptions] = useState({})
    const [designId, setDesignId] = useState(null)
    const [loading, setLoading] = useState(false)
    const trackId = useGlobalState()?.productTrackId
    const dispatch = useDispatch()
    const { id } = useParams()
    const { pathname } = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        if (styleInfo?.isSet) {
            ;(async () => {
                try {
                    dispatch(openLoader())
                    const data = await fetchSetInfoById(styleInfo.id)
                    setSetStyleIfo(data)
                    setDesignId(data?.setMemberProducts?.[0]?.id || null)
                    dispatch(closeLoader())
                } catch (e) {
                    dispatch(closeLoader())
                }
            })()
        } else {
            setDesignId(styleId)
        }
    }, [styleId])

    const generateParams = () => {
        let params = designId
        if (requestFrom === 'FAVOURITE') {
            params += '?fromFolder=true'
            if (id && id !== 'my-favourite') {
                params += `&folderId=${id}`
            }
        }
        return params
    }

    const fetchDesignInfos = async () => {
        try {
            dispatch(openLoader())
            const [productInfo, members, productDocs] = await Promise.all([
                fetchDesignInfoById(generateParams()),
                fetchCollectionMembersByProductId(designId),
                fetchDesignDocs(designId)
            ])
            setDesignInfo(productInfo)
            if (setCollectionMembers) setCollectionMembers(members)
            const defaultPresentationImages = productDocs?.productPresentationResponseList?.[0]?.documentResponse || []
            let defaultDocs = {
                front: {},
                back: {},
                fabric: {},
                embellishment: {}
            }
            if (defaultPresentationImages.length) {
                defaultPresentationImages.forEach((doc) => {
                    if (doc.docType === 'FRONT_IMAGE') {
                        defaultDocs.front = doc
                    } else if (doc.docType === 'BACK_IMAGE') {
                        defaultDocs.back = doc
                    } else if (doc.docType === 'FABRIC_IMAGE') {
                        defaultDocs.fabric = doc
                    } else if (doc.docType === 'EMBELLISHMENT') {
                        defaultDocs.embellishment = doc
                    }
                })
            }
            setDesignDocs(defaultDocs)
            setFeatureImageDocs(productDocs.featureImageDocResponse)
            setVirtualTryOnDocResponse(productDocs.virtualTryOnDocResponse)
            dispatch(closeLoader())
            const categoryId = isPickAndChooseBuyer()
                ? productInfo?.categoryResponse?.id
                : productInfo?.categoryId
            setLoading(true)
            const data = await fetchExploreDesigns('?page=0&size=6', {
                categoryIdList: [categoryId]
            })
            setDesignList(data.data)
            setTotalSimilarItems(data?.totalElements)
            setLoading(false)
            dispatch(closeLoader())
        } catch (e) {
            setLoading(false)
            dispatch(closeLoader())
        }
    }

    useEffect(() => {
        ;(async () => {
            try {
                if (designId !== null) {
                    await fetchDesignInfos()
                    const data = await callProductTracker(designId)
                    dispatch(CommonActions[ADD_PRODUCT_TRACK_ID](data))
                }
                // eslint-disable-next-line no-empty
            } catch (e) {}
        })()
        return () => {
            dispatch(CommonActions[CLEAR_PRODUCT_TRACK_ID]())
        }
    }, [designId])

    const handleZoomView = (imageType) => {
        if (selectedZoom === imageType) {
            setSelectedZoom(null)
        } else {
            setSelectedZoom(imageType)
        }
    }

    const handleFavourite = async (bool) => {
        try {
            await toggleFavouriteModal(bool, false)
            setShowFavourite(bool)
            setDesignInfo((prev) => ({ ...prev, liked: bool }))
        } catch (e) {
            toast.error('Something went wrong')
        }
    }

    const isShowPresentationImage = () => {
        if (
            designDocs?.front?.docUrl &&
            designDocs?.back?.docUrl &&
            designDocs?.embellishment?.docUrl &&
            designDocs?.fabric?.docUrl
        ) {
            return true
        }
    }

    const renderFileInfo = () => {
        return designInfo?.allNotImageDocuments?.map((file, index) => {
            const fileType = getFileType(file.docUrl)
            return (
                <tr
                    className='even:bg-white-shade-100'
                    key={`file_row_${index}`}
                >
                    <td className='text-base font-normal px-6 py-4 whitespace-nowrap'>
                        <div
                            className='flex items-center cursor-pointer'
                            onClick={() => window.open(file.docUrl, '_blank')}
                        >
                            <span>
                                {fileType === 'IMAGE' ? (
                                    <Image
                                        className='w-7 h-7 object-contain'
                                        src={file?.docUrl}
                                        alt=''
                                        isStatic={false}
                                    />
                                ) : (
                                    <span>
                                        <Image
                                            className='w-7 h-7 object-contain'
                                            src={getIconByFileType(fileType)}
                                            alt=''
                                            isStatic={false}
                                        />
                                    </span>
                                )}
                            </span>
                            <Tooltip title={file.name} placement={'top'} arrow>
                                <span className='regular-14 black ml-2'>
                                    {getShortName(file.name, 35)}
                                </span>
                            </Tooltip>
                        </div>
                    </td>
                </tr>
            )
        })
    }

    const onUpload = async (e) => {
        try {
            dispatch(closeLoader())
            let files = [...e.target.files]
            let allFileList = []
            await files.forEach((file) => {
                if (file) {
                    let data = {
                        name: file?.name,
                        docMimeType:
                            file?.type === ''
                                ? 'application/octet-stream'
                                : file?.type,
                        documentType: 'PRODUCT_NOT_IMAGE',
                        base64Str: ''
                    }
                    let reader = new FileReader()
                    reader.readAsDataURL(file)
                    reader.onload = () => {
                        data.base64Str = reader.result
                        allFileList.push(data)
                    }
                    reader.onerror = function (error) {
                        toast.error(error)
                    }
                }
            })
            setTimeout(async () => {
                await addProductBulkImages(allFileList, designId)
                const productInfo = await fetchDesignInfoById(generateParams())
                setDesignInfo(productInfo)
                dispatch(closeLoader())
            }, 100)
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const getSetDesignDocuments = (memberList) => {
        let designDocuments = []
        memberList.forEach((member) => {
            let memberDocuments = member.designDocuments?.map((item) => ({
                ...item,
                productId: member.id
            }))
            designDocuments = [...designDocuments, ...memberDocuments]
        })
        return designDocuments
    }

    const renderSetStyles = () => {
        if (styleInfo?.isSet) {
            return (
                <div className='flex justify-between flex-wrap sm:flex-nowrap mb-6'>
                    <div className='set-image-tab'>
                        {getSetDesignDocuments(
                            setStyleInfo?.setMemberProducts || []
                        )?.map((item) => {
                            return (
                                <Image
                                    key={`set_style_image_${item.id}`}
                                    src={item.docUrl}
                                    alt='style'
                                    className={
                                        item.productId === designId
                                            ? 'active'
                                            : ''
                                    }
                                    onClick={() => setDesignId(item.productId)}
                                    isStatic={false}
                                />
                            )
                        })}
                    </div>
                </div>
            )
        }
    }

    const onViewAllClick = () => {
        let categoryId, categoryName
        if (isPickAndChooseBuyer()) {
            categoryId = designInfo?.categoryResponse?.id
            categoryName = designInfo?.categoryResponse?.name
        } else {
            categoryId = designInfo?.categoryId
            categoryName = designInfo?.category
        }
        let selectedCategory = {
            id: categoryId,
            label: categoryName,
            value: categoryName
        }
        setFilterOptions((prevOptions) => ({
            ...prevOptions,
            categoryList: selectedCategory
        }))
        setIsViewAllClicked(true)
        const requestBody = {
            category: designInfo?.category
        }
        addMixpanelTrackingEvent(requestBody, 'BUYER_VIEW_SIMILAR_CATEGORY')
    }

    const renderMainFabricList = (fabricList) => {
        return fabricList?.map((item, idx) => {
            return (
                <h3 key={idx} className='regular-14 weight-700'>
                    {item?.name}
                </h3>
            )
        })
    }

    const onViewAllFabricClick = () => {
        let baseMaterialId = designInfo?.mainFabricResponses?.[0]?.libraryId
        let fabricName = designInfo?.mainFabricResponses?.[0]?.name

        let selectedFabrics = {
            id: baseMaterialId,
            label: fabricName,
            value: fabricName
        }

        setFilterOptions((prevOptions) => ({
            ...prevOptions,
            mainFabricList: selectedFabrics
        }))
        setIsViewAllClicked(true)

        const requestBody = {
            productId: designInfo?.id,
            category: designInfo?.category,
            department: designInfo?.productGroup,
            fabricName: designInfo?.mainFabricResponses?.[0]?.name
        }
        addMixpanelTrackingEvent(requestBody, 'BUYER_VIEW_SIMILAR_FABRIC')
    }

    useEffect(() => {
        dispatch(FilterActionTypes[ADD_FILTER_FIELDS]({ data: filterOptions }))
        if (isViewAllClicked) {
            if (pathname !== '/design-lab') {
                navigate('/design-lab')
            }
            onCloseModal()
        }
    }, [filterOptions])

    const toggleIsFavourite = async (bool, designInfo, isShowFav = true) => {
        if (!designInfo?.isSold) {
            setShowFavourite(true)
        } else {
            setShowFavourite(false)
        }
        await dispatch(
            DoFavouriteThunk[SELECT_DESIGN_FOR_FAVOURITE](designInfo, trackId)
        )
        await dispatch(FavouriteThunks[GET_FAVOURITE_COUNT]())
    }

    const renderSimilarDesigns = () => {
        return designList?.map((item, i) => {
            return (
                <React.Fragment key={`single_item_${i}`}>
                    <DesignCardView
                        designInfo={item}
                        triggerIsFavourite={toggleIsFavourite}
                    />
                </React.Fragment>
            )
        })
    }

    return (
        <>
            {openModal && (
                <ModalContainer
                    className='style-zoom-modal'
                    onCloseModal={onCloseModal}
                >
                    <div className='common-popup'>
                        <div className='common-popup-header d-flex justify-content-between'>
                            <div className='popup-tilte flex items-center'>
                                <h3 className='semibold-16 mb-0'>
                                    <span>
                                        {designInfo?.productGroup}
                                        {designInfo?.productGroup && ','}&nbsp;
                                    </span>
                                    {capitalizeFirstAndLowercaseRest(
                                        setStyleInfo?.isSet
                                            ? setStyleInfo?.name
                                            : designInfo?.name
                                    )}
                                    &nbsp;&nbsp;
                                    {!setStyleInfo?.isSet &&
                                        designInfo?.isPack && (
                                            <PackSetOrTag tagName='Pack' />
                                        )}
                                    {setStyleInfo?.isSet && (
                                        <PackSetOrTag tagName='Set' />
                                    )}
                                </h3>
                                <div className='ml-2'>
                                    <button
                                        className='button link'
                                        onClick={() => {
                                            navigator.clipboard.writeText(
                                                `${BASE_FRONT_END_URL}/design-view/${styleId}`
                                            )
                                            toast.success('Copied')
                                        }}
                                    >
                                        <span className='text-sm mr-2'>
                                            Copy design link
                                        </span>
                                        <CopyIcon width={20} height={20} />
                                    </button>
                                </div>
                            </div>
                            <div className='d-flex gap-2 items-center'>
                                <div className='actions-buttons mt-2 xl:mt-8'>
                                    <button
                                        className='button secondary icon-only mr-3'
                                        onClick={() =>
                                            toggleIsFavourite(true, designInfo)
                                        }
                                        disabled={!designInfo}
                                    >
                                        <span className='mr-1'>Favourite</span>
                                        <FavoriteIcon />
                                    </button>
                                    <button
                                        className='button secondary icon-only '
                                        onClick={() => {
                                            if (toggleConversation)
                                                toggleConversation(
                                                    designInfo?.id
                                                )
                                        }}
                                        disabled={!designInfo}
                                    >
                                        <ChatIcon />
                                    </button>
                                </div>
                                <div
                                    className='close-btn cursor-pointer'
                                    onClick={onCloseModal}
                                >
                                    <CloseIcon />
                                </div>
                            </div>
                        </div>
                        <div className='common-popup-body !py-0 sm:!pb-4 scroll-x-label'>
                            <div className='style-all-information'>
                                <div className='info-items mb-6'>
                                    <div className='single-info flex items-center mb-2'>
                                        <p className='regular-12 gray_300'>
                                            Design no
                                        </p>
                                        {designInfo?.referenceNumber && (
                                            <h3 className='regular-14 weight-700'>
                                                {designInfo?.referenceNumber}
                                            </h3>
                                        )}
                                    </div>

                                    <div className='single-info flex mb-2'>
                                        <p className='regular-12 gray_300'>
                                            Fabric
                                        </p>

                                        <div className='flex'>
                                            <div>
                                                {renderMainFabricList(
                                                    designInfo?.mainFabricResponses
                                                )}
                                            </div>
                                            <div>
                                                {isPickAndChooseBuyer() && (
                                                    <button
                                                        className='button link sm:ml-5 fabric-view-btn relative top-[-4px]'
                                                        onClick={() => {
                                                            onViewAllFabricClick()
                                                        }}
                                                    >
                                                        <span className='regular-12 weight-400'>
                                                            View Similar Fabric
                                                        </span>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {(designInfo?.buyerApprovedPrice ||
                                        (designInfo?.pickAndChooseOfferPrice &&
                                            isPickAndChooseBuyer())) && (
                                        <div className='single-info flex mb-2'>
                                            <p className='regular-12 gray_300'>
                                                Price
                                            </p>
                                            <h3 className='regular-14 weight-700'>
                                                {designInfo?.buyerApprovedPrice ? (
                                                    <>
                                                        $
                                                        {convertNumberToUSFormat(
                                                            designInfo?.buyerApprovedPrice
                                                        )}
                                                    </>
                                                ) : (
                                                    designInfo?.pickAndChooseOfferPrice &&
                                                    isPickAndChooseBuyer() && (
                                                        <>
                                                            $
                                                            {designInfo?.pickAndChooseOfferPrice?.toFixed(
                                                                2
                                                            )}
                                                        </>
                                                    )
                                                )}
                                            </h3>
                                            <ul className='gap-2 price-info'>
                                                <li className='gray_200'>
                                                    <span className='w-1 h-1 bg-[#999A9D] rounded-full mr-2 relative top-[-2px]'></span>
                                                    Price may vary
                                                </li>
                                                <li className='gray_200'>
                                                    <span className='w-1 h-1 bg-[#999A9D] rounded-full mr-2 relative top-[-2px]'></span>
                                                    Applicable for MOQ 1000.
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='d-flex flex-wrap md:!flex-nowrap gap-[12px]'>
                                <div className='all-images order-2 sm:!order-1'>
                                    {isShowPresentationImage() && (
                                        <div
                                            className={`style-and-fabric ${
                                                selectedZoom !== null
                                                    ? 'zoom-view'
                                                    : ''
                                            }`}
                                        >
                                            {designDocs?.front?.docUrl &&
                                                (selectedZoom === null ||
                                                    selectedZoom ===
                                                        'FRONT') && (
                                                    <div
                                                        className='single-image front'
                                                        onClick={() =>
                                                            handleZoomView(
                                                                'FRONT'
                                                            )
                                                        }
                                                    >
                                                        <Image
                                                            src={
                                                                designDocs
                                                                    ?.front
                                                                    ?.docUrl
                                                            }
                                                            isStatic={false}
                                                        />
                                                    </div>
                                                )}
                                            {designDocs?.back?.docUrl &&
                                                (selectedZoom === null ||
                                                    selectedZoom ===
                                                        'BACK') && (
                                                    <div
                                                        className='single-image back'
                                                        onClick={() =>
                                                            handleZoomView(
                                                                'BACK'
                                                            )
                                                        }
                                                    >
                                                        <Image
                                                            src={
                                                                designDocs?.back
                                                                    ?.docUrl
                                                            }
                                                            isStatic={false}
                                                        />
                                                    </div>
                                                )}
                                            {designDocs?.fabric?.docUrl &&
                                                (selectedZoom === null ||
                                                    selectedZoom ===
                                                        'FABRIC') && (
                                                    <div
                                                        className='single-image fabric'
                                                        onClick={() =>
                                                            handleZoomView(
                                                                'FABRIC'
                                                            )
                                                        }
                                                    >
                                                        <Image
                                                            src={
                                                                designDocs
                                                                    ?.fabric
                                                                    ?.docUrl
                                                            }
                                                            isStatic={false}
                                                        />
                                                    </div>
                                                )}
                                            {designDocs?.embellishment
                                                ?.docUrl &&
                                                (selectedZoom === null ||
                                                    selectedZoom ===
                                                        'EMBELLISHMENT') && (
                                                    <div
                                                        className='single-image fabric'
                                                        onClick={() =>
                                                            handleZoomView(
                                                                'EMBELLISHMENT'
                                                            )
                                                        }
                                                    >
                                                        <Image
                                                            src={
                                                                designDocs
                                                                    ?.embellishment
                                                                    ?.docUrl
                                                            }
                                                            isStatic={false}
                                                        />
                                                    </div>
                                                )}
                                        </div>
                                    )}
                                    {!isShowPresentationImage() &&
                                        featureImageDocs?.docUrl && (
                                            <div className='style-and-fabric zoom-view'>
                                                <div className='single-image'>
                                                    <Image
                                                        src={
                                                            featureImageDocs?.docUrl
                                                        }
                                                        isStatic={false}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                </div>
                                {virtualTryOnDocResponse?.docUrl && (
                                    <div className='all-content order-1 sm:!order-2'>
                                        <div className='ai-model-img'>
                                            <Image
                                                src={
                                                    virtualTryOnDocResponse?.docUrl ||
                                                    '/images/default_product.svg'
                                                }
                                                alt='ai-model-img'
                                                isStatic={
                                                    !virtualTryOnDocResponse?.docUrl
                                                }
                                            />
                                            <div className='ai-tag d-flex items-center justify-content-center'>
                                                <AiMagicIcon
                                                    width={24}
                                                    height={24}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='mt-3'>{renderSetStyles()}</div>
                            {!isShowPresentationImage() &&
                                designInfo?.referenceNumber && (
                                    <div className='files mt-6'>
                                        <table className='table'>
                                            <thead className='bg-white'>
                                                <tr>
                                                    <th className='flex justify-between'>
                                                        File
                                                        <div>
                                                            <input
                                                                id='designFileUpload'
                                                                type='file'
                                                                onChange={
                                                                    onUpload
                                                                }
                                                                onClick={(e) =>
                                                                    (e.target.value =
                                                                        null)
                                                                }
                                                                name='designFileUpload'
                                                                accept='*'
                                                                multiple
                                                                className='hidden'
                                                            />

                                                            <label
                                                                htmlFor='designFileUpload'
                                                                className='upload-blue-button flex items-center cursor-pointer'
                                                            >
                                                                Upload
                                                                <UploadIcon className='ml-2 w-6 h-6' />
                                                            </label>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>{renderFileInfo()}</tbody>
                                        </table>
                                    </div>
                                )}
                            <div className='similar-category-designs mt-10'>
                                {totalSimilarItems > 0 && (
                                    <div className='flex justify-between mb-4'>
                                        <h3 className='semibold-18'>
                                            Similar Category Designs (
                                            {totalSimilarItems})
                                        </h3>
                                        <button
                                            className='button link'
                                            onClick={() => {
                                                onViewAllClick()
                                            }}
                                        >
                                            View All
                                        </button>
                                    </div>
                                )}
                                {!loading && designList?.length > 0 && (
                                    <div className='design-list-container image-view 2xl:grid-cols-6'>
                                        {renderSimilarDesigns()}
                                    </div>
                                )}
                                {loading && (
                                    <div className='d-flex justify-content-center mt-5 pt-5'>
                                        <div className='round-loader'></div>
                                    </div>
                                )}
                                {!loading && designList?.length === 0 && (
                                    <p className='text-center text-base weight-500 py-16'>
                                        No similar design found!
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>

                    <AddToFavourite
                        isVisible={showFavourite}
                        setIsVisible={setShowFavourite}
                    />
                </ModalContainer>
            )}
        </>
    )
}

export default DesignViewModal
